'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { GlobalContext } from '~/context/flp/GlobalContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useRefreshTerms from '~/hooks/flp/services/useRefreshTerms';
import useTermsUpdated from '~/hooks/flp/useTermsUpdated';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/flp';

type OwnProps = {
  isLoggedIn: boolean;
};

export default function FinancingData({ isLoggedIn }: OwnProps) {
  const { isInitialized } = useFinancingContext();
  const refreshTerms = useRefreshTerms();

  // Initialize financing data if user is logged in
  useEffectOnce(
    () => {
      refreshTerms(true);
    },
    [refreshTerms],
    isLoggedIn
  );

  useNativeMessageListener();
  useNativeMessageDispatcher(!isLoggedIn || isInitialized);
  useTermsUpdated(isLoggedIn);

  const { hasUtmContentId } = useContext(GlobalContext);
  useTrackRendered('car-merch-ui-flp-sem-updated-modal', hasUtmContentId);

  return null;
}
